module.exports = __webpack_public_path__ + "static/media/3-2-bicovan.99f10792.jpg";